/* eslint-disable */
import services from 'services';
import mixpanel from '@/vendors/mixpanel/mixpanel';
import * as types from './mutation-types';

export default {
  loginWithUserToken: async ({ commit }, userToken) => {
    commit(types.LOGIN, {
      user: { userToken },
      userToken: userToken
    });
  },

  /**
   * Adds user to state and set state.authenticated value to true
   */
  loginWithCredentials: async ({ commit, dispatch, rootGetters }, { username, password }) => {
    const user = await services.AuthService.loginWithCredentials(username, password);
    dispatch('loginUser', user);
  },

  loginWithCustomToken: async ({ commit, dispatch }, userToken) => {
    const user = await services.AuthService.loginWithCustomToken(userToken);
    dispatch('loginUser', user);
    const customUser = await services.AuthService.getCurrentCustomTokenUserInfo();
    if (customUser) {
      // Important: cette partie permet de s'identifier avec un custom token
      // généré depuis l'app admin secteur.
      dispatch('updateUser', {
        user: {
          mail: customUser.email,
          name: `${customUser.firstname} ${customUser.lastname}`,
          password: "",
          uid: customUser.id,
        },
      });
    }
  },
  loginUser: async ({ commit, rootGetters }, user) => {
    const alreadyLoggedInBefore = rootGetters['auth/currentUserId'];
    const shop = rootGetters['shopAuth/currentShop'];
    if (!alreadyLoggedInBefore) {
      mixpanel.identify(user.uid);
      mixpanel.people.set({
        $email: user.email,
        $name: user.displayName,
        uid: user.uid,
      });
      if (shop && shop.shopEmail && shop.shopId) {
        mixpanel.people.set({
          emailMagasin: shop.shopEmail,
          idMagasin: shop.shopId,
        });
      }
    }
    commit(types.LOGIN, { user });
  },

  loginBo: async ({ commit }) => {
    const token = await services.BoAuthService.boflAuth();
    console.log('ACTION: ', token);
    commit('BO_AUTH', token);
  },

  /**
   * Removes user from state and reset state.authenticated
   */
  logout: ({ commit }) => {
    return services.AuthService.logout()
      .then(() => {
        commit(types.LOGOUT);
      });
  },
  /**
   * Replaces state.user by firebase.auth().currentUser
   */
  updateUser: ({ commit }, user) => {
    commit(types.UPDATE_USER, user);
  },

  GetAllUsers: async ({ commit }) => {
    const users = await services.AuthService.getUsersFromShop();
    commit(types.GET_USERS, users);
  },
  CleanStore: ({ commit }) => {
    commit(types.CLEAN_STORE);
  },
};
